import { Input, Modal, Select } from 'antd';
import React from 'react';
import ewtStore from '../EWTStore';
import { ewtModalClass } from '../theme';

const emptyTournament = () => ({
    code: '',
    currentRoundID: '',
    fan_code: '',
    name: '',
    orgID: '1',
});

export const DataTournamentEdit = (props) => {
    const [tournament, setTournament] = React.useState(null);
    const [rounds, setRounds] = React.useState([]);

    React.useEffect(() => {
        if (props.open) {
            if (props.tournament) {
                setTournament(JSON.parse(JSON.stringify(props.tournament)));
            } else {
                setTournament(emptyTournament());
            }
        }
    }, [props.open, props.tournament]);

    const tournamentId = tournament?.id;

    React.useEffect(() => {
        if (!props.open || !tournamentId) {
            setRounds([]);
            return;
        }
        ewtStore.firebaseDB
            .collection('rounds')
            .where('tournamentID', '==', tournamentId)
            .get()
            .then((snapshot) => {
                const tournamentRounds = snapshot.docs.map((doc) => {
                    const round = doc.data();
                    round.id = doc.id;
                    return round;
                });
                tournamentRounds.sort(
                    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
                );
                setRounds(tournamentRounds);
            });
    }, [props.open, tournamentId]);

    const save = async () => {
        const tournamentToSave = JSON.parse(JSON.stringify(tournament));
        delete tournamentToSave.id;
        tournamentToSave.orgID = '1';
        if (!tournamentToSave.currentRoundID) {
            delete tournamentToSave.currentRoundID;
        }

        if (tournament.id) {
            await ewtStore.updateOneDoc('tournaments', tournament.id, tournamentToSave);
        } else {
            const newId = await ewtStore.getNextSequentialId('tournaments');
            await ewtStore.setOneDoc('tournaments', newId, tournamentToSave);
        }
        await ewtStore.loadAllTournaments(true);
        props.hideModal();
    };

    return (
        <Modal
            className={ewtModalClass}
            title={tournament?.id ? 'Edit Tournament' : 'Add Tournament'}
            open={props.open}
            onOk={save}
            onCancel={props.hideModal}
            okText="Save"
            cancelText="Cancel"
        >
            {tournament && (
                <div className="flexColumn" style={{ gap: 8 }}>
                    <Input
                        addonBefore="Name"
                        value={tournament.name}
                        onChange={(e) =>
                            setTournament({ ...tournament, name: e.target.value })
                        }
                    />
                    <Input
                        addonBefore="Code"
                        value={tournament.code}
                        onChange={(e) =>
                            setTournament({ ...tournament, code: e.target.value })
                        }
                    />
                    <Input
                        addonBefore="Fan Code"
                        value={tournament.fan_code}
                        onChange={(e) =>
                            setTournament({ ...tournament, fan_code: e.target.value })
                        }
                    />
                    <div>
                        <div style={{ marginBottom: 4 }}>Current Round</div>
                        <Select
                            value={tournament.currentRoundID || undefined}
                            onChange={(value) =>
                                setTournament({ ...tournament, currentRoundID: value || '' })
                            }
                            allowClear
                            placeholder="No round selected"
                            style={{ width: '100%' }}
                            disabled={!tournament.id}
                        >
                            {rounds.map((round) => (
                                <Select.Option key={round.id} value={round.id}>
                                    {round.name} ({round.date})
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                </div>
            )}
        </Modal>
    );
};
